import { render, staticRenderFns } from "./FacialDeviceTableUserModal.vue?vue&type=template&id=ff881a4c&scoped=true&"
import script from "./FacialDeviceTableUserModal.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceTableUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff881a4c",
  null
  
)

export default component.exports